import { isValidUUID } from '../../../libs/isValidUUIDUtility';

export const assignmentAccessor = (
  assignedUsername,
  reviewers,
  admissionId,
  entityId
) => {
  let enabledReviewers = reviewers.filter((reviewer) => reviewer.enabled);

  enabledReviewers = isValidUUID(admissionId)
    ? enabledReviewers.filter(
        (r) => r.entities.filter((id) => id === entityId).length > 0
      )
    : enabledReviewers.filter(
        (r) =>
          r.entities.filter((id) => id === parseInt(entityId, 10)).length > 0
      );

  const user = assignedUsername
    ? enabledReviewers.find(({ username }) => username === assignedUsername)
    : null;

  const lastName = assignedUsername ? (user ? user.last_name : null) : '';

  return lastName;
};
